module.exports = __webpack_public_path__ + "src/img/banana/3.png?6d759e052790120f46ba1dee9d808fbf";


//////////////////
// WEBPACK FOOTER
// ./src/img/banana/3.png
// module id = 169
// module chunks = 0